export const servicesData = [
	{
		title: "ACT Logbook Training",
		slug: "act-logbook-training",
		metaTitle: "ACT Log Book Training |ACT Driving Test canberra ",
		metaDescription:
			"Learn smarter with ACT log book training in Canberra. Driving test preparation, expert guidance, and safe driving lessons to help you pass first time.",
		description:
			"Prepare for your ACT Learners Permit with Steer Smart’s ACT Logbook Training. Gain hands-on experience on local roads while mastering driving skills tailored to Canberra's traffic conditions. Our expert instructors will ensure you’re fully ready for the ACT driving test.",
		image:
			"https://images.unsplash.com/photo-1484373030460-8de45ac8796d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZHJpdmluZ3xlbnwwfHwwfHx8Mg%3D%3D",
	},
	{
		title: "NSW Logbook Training",
		slug: "nsw-logbook-training",
		metaTitle: "NSW Logbook Training Course | Driving Lessons Canberra",
		metaDescription:
			"NSW logbook course Canberra. Automatic driving lessons to complete hours, prepare for the driver licence test, and drive with confidence on Canberra roads.",
		description:
			"Take control of your driving with our NSW Logbook Training, perfect for those with a NSW Learners Permit. Learn how to navigate NSW roads confidently with SteerSmart’s practical, tailored lessons that cover local traffic, road signs, and intersections.",
		image:
			"https://images.unsplash.com/photo-1482029255085-35a4a48b7084?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHJpdmluZ3xlbnwwfHwwfHx8Mg%3D%3D",
	},
	{
		title: "One Off Driving Test Preparation",
		slug: "one-off-driving-test-preparation",
		metaTitle: "One Off Driving Test Prep | Driver Licence Practice",
		metaDescription:
			"One off driving lessons Canberra for test preparation. Automatic training with local driving school instructors to practise and prepare for your driver licence test.",
		description:
			"Our One-Off Driving Test Preparation course is ideal for anyone needing focused, intensive lessons before their test. We cover essential driving skills like parallel parking, emergency stops, and roundabout navigation, tailored to help you pass with confidence.",
		image:
			"https://images.unsplash.com/photo-1477071285213-9ba413bf77b2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjh8fGRyaXZpbmd8ZW58MHx8MHx8fDI%3D",
	},
	{
		title: "Refresher Driving Lessons for All Skill Levels",
		slug: "refresher-driving-lessons-for-all-skill-levels",
		metaTitle: "Refresher Driving Lessons | Driving Test Preparation Canberra ",
		metaDescription:
			"Driving lessons Canberra for beginners and refreshers. Affordable driving school packages, test prep with certified instructors, and strong pass rates. Book Now.",
		description:
			"Our refresher driving lessons help you regain confidence and refine your skills. Whether you are an overseas licence holder or just need to refresh your driving knowledge, our tailored lessons will guide you through the key aspects of driving in Canberra.",
		image:
			"https://images.unsplash.com/photo-1523138564298-2773209aef9b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjl8fGRyaXZpbmd8ZW58MHx8MHx8fDI%3D",
	},
	{
		title: "For Interstate Licence Holders",
		slug: "for-interstate-licence-holders",
		metaTitle: "Interstate Licence Holders Canberra | Driver Licence Guide",
		metaDescription:
			"Need an ACT licence in Canberra? Interstate licence holders can convert their driver licence quickly. Full guide on process, documents, and driving test.",
		description:
			"Our training course for interstate licence holders is designed to help you adapt to Canberra’s unique road rules and conditions. You'll learn everything you need to know to drive confidently, including local traffic patterns and parking regulations.",
		image:
			"https://images.unsplash.com/photo-1482029255085-35a4a48b7084?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHJpdmluZ3xlbnwwfHwwfHx8Mg%3D%3D",
	},
	{
		title: "Customized Driving Lessons",
		slug: "customized-driving-lessons",
		metaTitle: "Customized Driving Lessons Canberra | Local Driving School",
		metaDescription:
			"Customised driving lessons Canberra—local driving school, flexible hours, modern cars, Affordable driving lessons, and trusted driving test preparation.",
		description:
			"Our customized driving lessons are designed to meet your individual needs. Whether you need to improve defensive driving, master specific manoeuvres, or simply build confidence, we provide a personalized approach that ensures steady progress.",
		image:
			"https://images.unsplash.com/photo-1482029255085-35a4a48b7084?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHJpdmluZ3xlbnwwfHwwfHx8Mg%3D%3D",
	},
];
